import styled from 'styled-components';
import { Button } from '../../../lib/jfy-ui';

export const CAButton = styled(Button)`
  height: 1.2rem;
  ${(props) =>
    props.isCheckout? 'min-height: 50%' : ''}
`;
